// useDeleteThread — mutation to delete a thread by ID.
// Invalidates the thread list on success.

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createApiClient } from '@/shared/api';
import { getToken } from '@/shared/auth';
import { readEnv } from '@/shared/config';
import { invalidateThreadList } from './invalidate';

function getClient() {
  return createApiClient({
    baseUrl: readEnv('VITE_API_BASE_URL') ?? '',
    auth: { getToken },
  });
}

async function deleteThread(threadId: string): Promise<void> {
  await getClient().request({
    method: 'DELETE',
    path: `/api/v1/sessions/${encodeURIComponent(threadId)}`,
  });
}

export function useDeleteThread() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (threadId: string) => deleteThread(threadId),
    onSuccess: () => {
      void invalidateThreadList(queryClient);
    },
  });

  return {
    deleteThread: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
